export default function Footer() {
  return (
    <div className="footer">
      {/* <p>Data derived from USGS web services.</p> */}
    </div>
  )
}
